const QuestionsComponent = {
    data()
    {
        return {
            activeTab: 0,
        };
    },

    methods: {
        setTab( index )
        {
            this.activeTab = index;
        },
    },
};

window.QuestionsComponent = QuestionsComponent;